export function initGardu() {
    // Edit logic
    $(document).on('click', '.btn-edit-gardu', function() {
        const url = $(this).data('url-json');
        $('#modalEditGarduLabel').html('<i class="bi bi-pencil-square me-2"></i>Edit Master Gardu');
        
        $.get(url, async function(response) {
            if (response.status === 'success') {
                const data = response.data;
                
                // Get the base update URL from a data attribute on the form
                const baseUrl = $('#formEditGardu').data('update-url');
                $('#formEditGardu').attr('action', baseUrl + '/' + data.id_gardu);
                
                $('#edit_id_gardu').val(data.id_gardu);
                $('#edit_kode_gardu').val(data.kode_gardu);
                $('#edit_nomor_gardu').val(data.nomor_gardu);
                $('#edit_nama_gardu').val(data.nama_gardu);
                $('#edit_kapasitas').val(data.kapasitas);
                $('#edit_latitude').val(data.latitude);
                $('#edit_longitude').val(data.longitude);
                $('#edit_radius').val(data.radius || 100);
                $('#edit_fasa').val(data.fasa).trigger('change');
                $('#edit_status').val(data.status).trigger('change');
                
                $('#modalEditGardu').modal('show');

                // Advanced cascading: wait for children to load before setting value
                $('#edit_id_up3').val(data.id_up3).trigger('change');
                
                if (data.id_ulp) {
                    await new Promise(resolve => {
                        $('#edit_id_ulp').one('cascadingComplete', resolve);
                        setTimeout(resolve, 3000);
                    });
                    $('#edit_id_ulp').val(data.id_ulp).trigger('change');
                    
                    if (data.id_penyulang) {
                        await new Promise(resolve => {
                            $('#edit_id_penyulang').one('cascadingComplete', resolve);
                            setTimeout(resolve, 3000);
                        });
                        $('#edit_id_penyulang').val(data.id_penyulang).trigger('change');
                    }
                }
                
                $('#edit_id_jenis_gardu').val(data.id_jenis_gardu).trigger('change');
            }
        });
    });

    $('#btnCreateGardu').on('click', function() {
        $('#modalGarduLabel').html('<i class="bi bi-hdd-network me-2"></i>Tambah Master Gardu');
        $('#formGardu')[0].reset();
        
        $('#formGardu').find('.select2').val('').trigger('change');
        $('#add_radius').val(100);
    });

    $('#formGardu, #formEditGardu').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = $(this).find('button[type="submit"]');
        if (btn.prop('disabled')) return; // Prevent double submission

        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');
        
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: $(this).serialize(),
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire('Berhasil', res.message, 'success').then(() => location.reload());
                }
            },
            error: function(err) {
                btn.prop('disabled', false).text('Simpan');
                const res = err.responseJSON;
                const errorMsg = res?.errors?.kode_gardu || res?.message || 'Terjadi kesalahan';
                Swal.fire('Error', errorMsg, 'error');
            }
        });
    });

    // NOTE: Delete is handled by global-crud.js via .btn-delete-submit

}
